import { useCurrentCommunityContext } from "@circle-react/contexts/currentCommunityContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useUpdateCommunity } from "@circle-react/hooks/useUpdateCommunity";

import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";

export interface FormValues {
  cover_image: string;
}

export const useEditHomeCover = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const { mutateAsync: updateCommunity, isPending: isUpdating } =
    useUpdateCommunity();

  const {
    actions: { refresh },
    helpers: { isDataRefreshing },
    record: { home_page_cover_image_url: coverImageUrl },
  } = useCurrentCommunityContext();

  const onSubmit = (formValues: FormValues) => {
    void updateCommunity({
      community: { home_page_cover_image: formValues.cover_image },
    });
  };

  const onDelete = async () => {
    await updateCommunity({
      community: { home_page_cover_image: null },
    });
    await refresh();
  };

  const isSmallScreen = useSmScreenMediaQuery();
  const coverImage = coverImageUrl || "";
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isLoading = isUpdating || Boolean(isDataRefreshing?.());
  const hasCoverImage = Boolean(coverImage);

  return {
    coverImage,
    hasCoverImage,
    isAdmin,
    isLoading,
    isSmallScreen,
    onDelete,
    onSubmit,
  };
};
